import Reception from './Reception.jsx';
import { ShiftGate } from '../../shared/ShiftGate.jsx';

export default {
  path: '/reception',
  element: <ShiftGate what="استقبال الأطفال"><Reception /></ShiftGate>,
  protected: true,
  permission: 'reception.create',
  standalone: false,
  sidebar: { label: 'الاستقبال', icon: 'reception', group: 'main', order: 20 }
};
